export const BillingAlertLocalStorageKeys = {
  billingAlertModalAcknowledged: 'billing-alert-modal-acknowledged',
};
